import { Platform } from "react-native";

let ActionSheetIOS = null;

if (Platform.OS === "ios") {
  const { ActionSheetIOS: NativeActionSheetIOS } = require("react-native");
  ActionSheetIOS = NativeActionSheetIOS;
}

export default ActionSheetIOS;
